import { useState } from "react";
import { Link } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { ArrowLeft, Download, Images, Star } from "lucide-react";

const BASE = "https://static.prod-images.emergentagent.com/jobs/1b66fcb6-686c-496a-809e-79f0cfe50fdc/images/";
const img = (slide) => `${BASE}${slide.hash}.${slide.ext || "png"}`;

const GROUPS = [
  {
    key: "offerta-irresistibile",
    title: "Carosello · Offerta irresistibile (perché funziona)",
    desc: "6 slide — Value Equation: risultato, prova, tempo, zero sforzo.",
    slides: [
      { n: "01", label: "Cover · Perché funziona", hash: "e1c2ac4b6272585cf46f4f0236c2b3a66a60f28b31b183e494845468a28a696b", ext: "jpeg" },
      { n: "02", label: "Il risultato", hash: "267d9121f3a0e3a7163dcf6826c9e29a7ea00e5cf02a3dc8a5ccc96bcac69c75", ext: "jpeg" },
      { n: "03", label: "La prova · non sei il primo", hash: "8be310f60e10682cd13003d604dad4efa905004e8abe3d39132ee27c391bd878", ext: "jpeg" },
      { n: "04", label: "Subito · risultato immediato", hash: "65eee8981d2018c2a019c0b8f8f341ffd39189dd5452bb151466476e034857b0", ext: "jpeg" },
      { n: "05", label: "Zero pensieri · faccio tutto io", hash: "ac56cc9d2135b46442d128a396ac6248f300dc1dffb5edf0ad13214616b6a147", ext: "jpeg" },
      { n: "06", label: "CTA · Scrivi MAPPA", hash: "c88d4f765a6f2fff6470b6ebbbdb7689bf05a57b695a0aa3d2ea254669cf61bf", ext: "jpeg" },
    ],
  },
  {
    key: "hai-3-secondi",
    title: "Carosello · Hai 3 secondi (quanto perdi)",
    desc: "6 slide — reel-tip educativo che porta traffico al calcolatore.",
    slides: [
      { n: "01", label: "Cover · Hai 3 secondi", hash: "f21635b822470bb256f43e8a7105449e43891cc6df89547863cd0d21c90005be", ext: "jpeg" },
      { n: "02", label: "Il calcolo", hash: "0ed26168dbe863a25c9faf908610a6ab2a9b514771e9542768bcbcc3076db201", ext: "jpeg" },
      { n: "03", label: "In 10 anni: -15.000€", hash: "9c2e472bed5563c867f5cefd6b05533fa2737e7d55d1fe6afea7370420add7b7", ext: "jpeg" },
      { n: "04", label: "I soldi fermi non sono al sicuro", hash: "3445a8a5a65a85a7fe7329a0236f6b9713f88d06138098580b7f8bc014da9343", ext: "jpeg" },
      { n: "05", label: "La soluzione · bene reale", hash: "943e17d7b896b6dc82271ed0d5f39cbf02136f22c1331523180b2ab972effae3", ext: "jpeg" },
      { n: "06", label: "CTA · Calcola link in bio", hash: "034952d04dd5212b8048fd3d2f1d36bd5d812dfbb42d192ff776c3c2aacd0866", ext: "jpeg" },
    ],
  },
  {
    key: "lavora-con-me",
    title: "Lavora con me · slide + copertina Highlight",
    desc: "Slide offerta (4 punti) + copertina Highlight con stretta di mano.",
    slides: [
      { n: "01", label: "Slide · Lavora con me", hash: "7e55f75a58f454ebf73911b022d5f524670a23fe2a2315332aa68ef54992c792", ext: "jpeg" },
      { n: "★", label: "Copertina Highlight", hash: "93f8317355c7a4bf9ef6896a1921af7dfcc901f697dd72af9ad0d6fa4fde9b99", ext: "jpeg" },
    ],
  },
  {
    key: "chi-sono",
    title: "Carosello · Chi sono (presentazione)",
    desc: "5 slide — foto + manifesto Perché/Come/Cosa. Ideale come post fissato.",
    slides: [
      { n: "01", label: "Chi sono · foto", hash: "a35cb730e7bbf432b3e4658e54356181d5b41bc4671b4c9ab1fa7ac5bc423eab", ext: "jpeg" },
      { n: "02", label: "Perché · Credo che...", hash: "52685ef07b9d2bd1bc1f123e5b13fd3abb4b99a62df14656024dda0b42363b68", ext: "jpeg" },
      { n: "03", label: "Come · percorso in 5 fasi", hash: "85744c72ec2460a9781d3884b9d94b0723cccfd186180070f197f817524a13a6", ext: "jpeg" },
      { n: "04", label: "Cosa · liquidità in oro fisico", hash: "3ce702e0ea1321ea0c7ceee9f2fb877d4f7f050fec5ab1ad74415b950769422e", ext: "jpeg" },
      { n: "05", label: "CTA · Scrivi MAPPA", hash: "598622f3fa7f6cc155c1d9cb5c0bba5ac0f0b8e9a842bc53b9f267245fb0f21c", ext: "jpeg" },
    ],
  },
  {
    key: "perche-come-cosa",
    title: "Carosello · Perché → Come → Cosa (manifesto)",
    desc: "5 slide — il Golden Circle: perché faccio questo. Ottimo per presentarti.",
    slides: [
      { n: "01", label: "Cover · Perché faccio questo", hash: "8fac6cd1a1e819ee126eb9c7c5e1ce75a7af9b504b8ff3881c90a51daaefd67f", ext: "jpeg" },
      { n: "02", label: "PERCHÉ · Proteggere, non subire", hash: "5b46af5f325d7e23c679e9aaa733b311920e20740b8f75a0e3b4957d1489788a", ext: "jpeg" },
      { n: "03", label: "COME · Un percorso, non una vendita", hash: "f104be4a7ac8b9fc2373ba81a9bbd6fd87e93b60be5d9d4453056a78b4fc3cf2", ext: "jpeg" },
      { n: "04", label: "COSA · Liquidità ferma in oro reale", hash: "3a130a462a8ce0d53c0d68e7b904b89c3243f12190f059eb1601a4e868bd834f", ext: "jpeg" },
      { n: "05", label: "CTA · Scrivi MAPPA", hash: "5608e33f89e4fba2f076931d205b63b9433e7542cdf1baf40a4cf5ba59cc5789", ext: "jpeg" },
    ],
  },
  {
    key: "metodo-5-fasi",
    title: "Carosello · Il Metodo Alex Gold (5 fasi)",
    desc: "7 slide — 'Come lavoro con te'. Ideale come post fissato (pinned).",
    slides: [
      { n: "01", label: "Cover · Come lavoro con te", hash: "86b1bd208645fb1b0b6825c006ec9789375c7d222f7f83bdb26e3ac34ac90662", ext: "jpeg" },
      { n: "02", label: "1 · Analisi", hash: "d9f2a168779456a8570e8f7e5d403d69cca68c26ab4dc8ff896e03147e5d33d5", ext: "jpeg" },
      { n: "03", label: "2 · Strategia", hash: "b2ecbd3515aeb0af9c6888163fe51ea6d5a6637a65f372e246a5abd0d84ee3d1", ext: "jpeg" },
      { n: "04", label: "3 · Accumulo programmato", hash: "2a858b39af452af6fb1aef1db35d09a570c33db8f5acaff060fe9be1f2f92cb8", ext: "jpeg" },
      { n: "05", label: "4 · Custodia sicura", hash: "1ac0539d1e561ee6ea842ff26e4f3c30a7c3dab4dfd30908bd2839ec81a63337", ext: "jpeg" },
      { n: "06", label: "5 · Accompagnamento ciclico", hash: "cda918ccb4b314a6b028ebbaea55912af3e516e3b463b672c1ff9668d61e81d8", ext: "jpeg" },
      { n: "07", label: "CTA · Scrivi MAPPA", hash: "5ef9d54836cbb034dde8be809ef4770648832fb7b3b6455c90b5888fefe4c1e5", ext: "jpeg" },
    ],
  },
  {
    key: "perche-oro",
    title: "Carosello · Perché l'oro (percorso & metodo)",
    desc: "9 slide — manifesto: non vendo un prodotto, costruisco un percorso.",
    slides: [
      { n: "01", label: "Cover · Perché l'oro", hash: "931df7ff112ee5b32eeefe42c7fb2ad5170cbe7a814f421022f8d3bf93a2bd72", ext: "jpeg" },
      { n: "02", label: "Attraversa i secoli", hash: "56da246a4c09eb9872c3379fe8e24d66c2be42ae5049034cc72f3d9c74dd23b6", ext: "jpeg" },
      { n: "03", label: "Non vendo un prodotto", hash: "e44bee03952ef6406231a098dcb412f51cd49bd554f3785219f1b32f95a7109d", ext: "jpeg" },
      { n: "04", label: "Disciplina > emotività", hash: "67838ac79c7a794b7f1cdb637ea13cec48490909eb547d08dc5fb7e9305c229e", ext: "jpeg" },
      { n: "05", label: "Il tempo, non la fortuna", hash: "8a2e718644304d4d7647967edb93cce4712273b4e9eaff5affe6ea60fe41fdb6", ext: "jpeg" },
      { n: "06", label: "Relazione, non transazione", hash: "cea8f64401522f24a3eead956457f31144373fb9bbba96722562fb2e510168d5", ext: "jpeg" },
      { n: "07", label: "Il metodo è la forza", hash: "659f7021c9bfc071563df1dbc75ea9f59c359b75e7d35e147774e76dfff5cfc9", ext: "jpeg" },
      { n: "08", label: "Cicli di fiducia", hash: "288cbe4fd5a1c15b522d315e7d7c863059a905f4460e2dbecff4d023c09800a9", ext: "jpeg" },
      { n: "09", label: "CTA · Inizia il percorso", hash: "8d4a25a6862e3f245f3fa9f411f7dfa1486c02c9b52df358333f1f40518e4477", ext: "jpeg" },
    ],
  },
  {
    key: "obiezioni",
    title: "Carosello · 6 obiezioni sull'oro sfatate",
    desc: "8 slide — mito da sfatare + risposta. Chiude con CTA 'Scrivi MAPPA'.",
    slides: [
      { n: "01", label: "Cover", hash: "dd5c174f41b1186b6bcf133412dc20aa9cb8e373b8fff4dac2643bdf2c6c7bc6" },
      { n: "02", label: "L'oro non rende", hash: "bac3c0a28f81337f3030c6cb611d59eb367facaa12b081ee45e0ed525d0c6ec6" },
      { n: "03", label: "Dove lo tengo?", hash: "1b77083995575b30c7ad3dc529b9dbc1e55c22e329b533cc07c99424bdedcacc" },
      { n: "04", label: "È difficile venderlo", hash: "47428388a1d7686b8f3d0599b5e0804c74de20f7f899d020371baf9793ebfe0c" },
      { n: "05", label: "Costa troppo ora", hash: "2f52663f92e6d01884d5f563e033a84e8713c4486caf026edc931b128e4e8c89" },
      { n: "06", label: "Sembra una truffa", hash: "4269a20ba6c1542e0e44da584e64fcb6e7b2049938ad8023e11b1201522ee75e" },
      { n: "07", label: "Meglio il mattone", hash: "3ba97627892713aad1c0e6629b1b58b34c962de85585846bd5bc771d22484c55" },
      { n: "08", label: "CTA · Scrivi MAPPA", hash: "baefda600c5f2770908a0fcd3c5782e24335f159cf95108d48e93428100e29e6" },
    ],
  },
  {
    key: "oro",
    title: "Carosello · L'oro è tornato a correre",
    desc: "5 slide — perché l'oro sale e cosa c'entra col tuo patrimonio.",
    slides: [
      { n: "01", label: "Cover", hash: "ddd019655059a4b40d6d1eba095cbc40474b7985fedc5f76993f01a57eb86a37" },
      { n: "02", label: "Perché sale", hash: "446c951f1047e94eba6010ea8757ff4844844dbcbce58852dfe8686c7e85189b" },
      { n: "03", label: "Prezzo oggi", hash: "6357ac6fab3f25869ad3bb5073226db915397d5ea2abe89b21fedde1b091fa77" },
      { n: "04", label: "Come farlo bene", hash: "bacd0c6a7d9ae9a23edd320287f389a58abca4194a899d84100e2d7cbbda576f" },
      { n: "05", label: "CTA · Commenta ORO", hash: "1dbbd8ce5a818ffece10693a340758300662d6942e168facea9778091e6470b9" },
    ],
  },
  {
    key: "recensioni",
    title: "Testimonianze · Highlight RECENSIONI",
    desc: "3 recensioni clienti + copertina Highlight.",
    slides: [
      { n: "01", label: "Marco — Imprenditore SRL", hash: "8b61eec11d4e1f5ea1aa49cfc94a232cf2bf2d9552995ed92ff9ef1f14bebb72" },
      { n: "02", label: "Roberto — Libero prof.", hash: "002cb61e79729e1d0fb59834b6d9ad63829cac6b1d583f902ffd392c2e6d3139" },
      { n: "03", label: "Alessandro — Cliente", hash: "357a48321f467f4c6c7022ca29774246cd082fb93969cccfa4a2b6d368b2dd56" },
      { n: "★", label: "Copertina Highlight", hash: "39d8d05c2c376a87240266af2de4f1221e811b55c43704fc46974872bfd72ab6" },
    ],
  },
];

async function downloadImage(url, filename) {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
    return true;
  } catch {
    window.open(url, "_blank");
    return false;
  }
}

function Slide({ groupKey, slide, index }) {
  const url = img(slide);
  const filename = `${groupKey}_${slide.n}.${slide.ext || "png"}`;
  return (
    <div className="bg-zinc-900 border border-zinc-800 overflow-hidden group" data-testid={`slide-${groupKey}-${index}`}>
      <a href={url} target="_blank" rel="noreferrer" className="block relative">
        <img src={url} alt={slide.label} loading="lazy" className="w-full aspect-[3/4] object-cover" />
        <span className="absolute top-2 left-2 text-[10px] font-mono bg-black/70 text-yellow-500 px-1.5 py-0.5">{slide.n}</span>
      </a>
      <div className="p-2.5 flex items-center justify-between gap-2">
        <span className="text-xs text-zinc-400 truncate">{slide.label}</span>
        <button onClick={() => downloadImage(url, filename)} data-testid={`download-${groupKey}-${index}`}
          className="shrink-0 flex items-center gap-1 text-[11px] text-yellow-500 hover:text-yellow-400 transition-colors">
          <Download size={13} /> Scarica
        </button>
      </div>
    </div>
  );
}

export default function Materiale() {
  const [busy, setBusy] = useState("");

  const downloadAll = async (group) => {
    setBusy(group.key);
    for (const s of group.slides) {
      await downloadImage(img(s), `${group.key}_${s.n}.${s.ext || "png"}`);
      await new Promise((r) => setTimeout(r, 600));
    }
    setBusy("");
    toast.success(`${group.slides.length} immagini scaricate`);
  };

  return (
    <div className="bg-zinc-950 text-zinc-50 min-h-screen">
      <Toaster theme="dark" position="top-right" />
      <header className="border-b border-zinc-800 px-4 md:px-8 py-4 flex items-center justify-between sticky top-0 bg-zinc-950/95 backdrop-blur z-20">
        <div className="flex items-center gap-3">
          <div className="bg-yellow-500 p-2"><Images size={20} className="text-black" /></div>
          <div>
            <h1 className="font-head font-extrabold text-xl tracking-tight leading-none">MATERIALE</h1>
            <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500">Caroselli & grafiche pronte</p>
          </div>
        </div>
        <Link to="/radar" data-testid="link-radar"
          className="flex items-center gap-1.5 text-zinc-400 hover:text-yellow-500 text-sm transition-colors">
          <ArrowLeft size={15} /> Radar
        </Link>
      </header>

      <main className="max-w-6xl mx-auto px-4 md:px-8 py-8 space-y-12">
        {GROUPS.map((group) => (
          <section key={group.key} data-testid={`group-${group.key}`}>
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-4">
              <div>
                <h2 className="font-head font-bold text-2xl tracking-tight flex items-center gap-2">
                  {group.key === "recensioni" ? <Star size={20} className="text-yellow-500" /> : <Images size={20} className="text-yellow-500" />}
                  {group.title}
                </h2>
                <p className="text-sm text-zinc-500 mt-1">{group.desc}</p>
              </div>
              <button onClick={() => downloadAll(group)} disabled={busy === group.key} data-testid={`download-all-${group.key}`}
                className="shrink-0 flex items-center gap-2 bg-yellow-500 text-black font-semibold hover:bg-yellow-400 disabled:opacity-60 px-4 py-2.5 text-sm transition-colors rounded-full">
                <Download size={15} /> {busy === group.key ? "Scarico..." : "Scarica tutte"}
              </button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {group.slides.map((s, i) => (
                <Slide key={s.hash} groupKey={group.key} slide={s} index={i} />
              ))}
            </div>
          </section>
        ))}
        <p className="text-center text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-600 pt-4">
          Alex Gold · Materiale contenuti
        </p>
      </main>
    </div>
  );
}
